import request from '@/utils/request'


// 查询用户体温记录列表
export function listBodytemperature(query) {
  return request({
    url: '/joe/user-bodytemperature/list',
    method: 'get',
    params: query
  })
}

// 查询用户体温记录分页
export function pageBodytemperature(query) {
  return request({
    url: '/joe/user-bodytemperature/page',
    method: 'get',
    params: query
  })
}

// 查询用户体温记录详细
export function getBodytemperature(data) {
  return request({
    url: '/joe/user-bodytemperature/detail',
    method: 'get',
    params: data
  })
}

// 新增用户体温记录
export function addBodytemperature(data) {
  return request({
    url: '/joe/user-bodytemperature/add',
    method: 'post',
    data: data
  })
}

// 修改用户体温记录
export function updateBodytemperature(data) {
  return request({
    url: '/joe/user-bodytemperature/edit',
    method: 'post',
    data: data
  })
}

// 删除用户体温记录
export function delBodytemperature(data) {
  return request({
    url: '/joe/user-bodytemperature/delete',
    method: 'post',
    data: data
  })
}
